"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var logger_1 = require("./util/logger");
var VFExternalTexture = (function () {
    function VFExternalTexture(scene, properties) {
        this.scene = scene;
        this.properties = properties;
        if (properties["object"]) {
            this.object = scene.model.getObjectForHash(properties["object"].toString());
            this.objectPath = this.object["path"] + this.object["name"];
        }
        if (properties["target_material"]) {
            this.material = this.scene.getMaterialForHash(properties["target_material"]);
        }
    }
    VFExternalTexture.prototype.loadFromUrl = function (textureUrl, alpha) {
        if (alpha === void 0) { alpha = -1; }
        if (!this.material) {
            logger_1.default.error("target material not found");
            return;
        }
        var hasAlpha = textureUrl.includes(".png") || alpha === 1;
        if (alpha === 0) {
            hasAlpha = false;
        }
        var texture = new babylonjs_1.Texture(textureUrl, this.scene, false, false, babylonjs_1.Texture.LINEAR_LINEAR_MIPLINEAR, null, null, null, null, hasAlpha ? babylonjs_1.Engine.TEXTUREFORMAT_RGBA : babylonjs_1.Engine.TEXTUREFORMAT_RGB);
        if (hasAlpha === true) {
            texture.hasAlpha = true;
        }
        texture.name = this.material.name + "_EXTERNAL";
        this.material.setTexture(texture);
    };
    return VFExternalTexture;
}());
exports.default = VFExternalTexture;
